import TwilioActionsBarContainer from './TwilioActionsBarContainer';

import { Loading, Flex } from '@amigoapp/doca-react';

const TwilioVideoRoom = ({ loading, room, previewTracks, devices }) => (
	<Flex className="doca-bg-white" direction="col" flex={1}>
		{loading && <Loading className="absolute" />}
		<div className="doca-flex doca-flex-1 doca-justify-center doca-bg-dark-high" id="doctor-tracks" />
		<div className="doca-bg-dark-low" id="patient-tracks">
			{loading && <Loading />}
		</div>
		<TwilioActionsBarContainer
			devices={devices}
			previewTracks={previewTracks}
			room={room}
		/>
	</Flex>
);

export default TwilioVideoRoom;
